const HeaderLogo: React.FC = () => {


    if (process.env.NODE_ENV === 'development') {
        return null;
    }

    return (
        <div className="flex items-center">
            <img src="/raytd_logo.png" alt="logo" className="h-8 w-auto" />
        </div>
    )
}

export default HeaderLogo;